import { useCallback, useEffect, useState } from 'react'
import { listChatrooms } from '../services/chatrooms'

// Rooms the signed-in user belongs to. `q` is debounced; topic ids are a
// joined string so a new array identity does not refetch.
export function useChatrooms(q, topicKey) {
  const [rooms, setRooms] = useState([])
  const [status, setStatus] = useState('loading')
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick((n) => n + 1), [])

  useEffect(() => {
    let alive = true
    const handle = setTimeout(() => {
      setStatus('loading')
      const topics = topicKey ? topicKey.split(',').filter(Boolean) : []
      listChatrooms({ q: q.trim(), topics })
        .then((list) => {
          if (!alive) return
          setRooms(list || [])
          setStatus('ready')
        })
        .catch(() => {
          if (alive) setStatus('error')
        })
    }, q.trim() ? 250 : 0)
    return () => {
      alive = false
      clearTimeout(handle)
    }
  }, [q, topicKey, tick])

  return { rooms, setRooms, status, reload }
}
